import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { LayoutStore } from "./types";

const useLayoutStore = create<LayoutStore>()(
  immer((set) => ({
    isDocumentationBarVisible: false,
    showMobileMenu: true,
    showFilters: false,
    isFullScreenModalOpen: false,
    setIsDocumentationBarVisible: (value) => set({ isDocumentationBarVisible: value }),
    setShowMobileMenu: (value) => set({ showMobileMenu: value }),
    setShowFilters: (value) => set({ showFilters: value }),
    setIsFullScreenModalOpen: (value) => set({ isFullScreenModalOpen: value }),
  }))
);

export default useLayoutStore;
